import React from "react";
import "./surrounding.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Surroundingimages from "./surrounding.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faCheckDouble,
  faGraduationCap,
  faHouse,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";

const lokasi = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="surroundingarea" className="surroundingarea">
      <div className="container-surrounding">
        <div id="surrounding" className="judul-surrounding">
          <h1>Surrounding Area</h1>
        </div>
        <div className="container-card">
          <div className="kartu">
            <Slider {...settings}>
              {Surroundingimages.map((image, index) => (
                <div>
                  <img
                    className="kartugambar1"
                    key={index}
                    src={image}
                    alt="athena"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="feature1">
          <div className="feature-list11">
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;7 Menit ke Prastya Mulya University
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Atma Jaya University
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Binus University
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Al-Azhar BSD School
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Pelita Harapan University
              </span>
            </div>
          </div>
          <div className="feature-list11">
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;5 Menit ke Mitra Keluarga Hospital
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Eka Hospital
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Columbia Asia BSD
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;15 Menit ke Mayapada Hospital
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;15 Menit ke RS Hermina Serpong
              </span>
            </div>
          </div>
          <div className="feature-list11">
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Ocean Park BSD
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Living World
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke The Breeze BSD
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Teras Kota
              </span>
            </div>
            <div className="surroundingarea1">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;10 Menit ke Taman Kota
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default lokasi;
